module.exports = __webpack_public_path__ + "img/icon-exclamationmark.145e8ce3.png";